import React from 'react';
import { Link } from 'react-router-dom'; // Assuming you're using react-router-dom
import './about.css';

function About() {
    return (
        <div className='about_container'>
            <h1 className='how_header'>Meet Bog Bot, featuring BogAI!</h1>

                <h2 className='sub_header'>Getting Started</h2>
                <p>
                    <ul>
                        <li>To get start Bog Bot has to be invited to your server, which you can do <Link to="https://discord.com/oauth2/authorize?client_id=966713693637337149&permissions=2151148608&integration_type=0&scope=bot"><b>here</b></Link>.</li>
                        <li>Once Bog Bot is in your server, you can start using it by typing <b>/</b> in the chat and selecting the command you want to use or tag the bot with <b>@bogbot</b> to start conversing</li>
                        <li>To see a list of all the commands you can use, type <b>/help</b> in the chat.</li>

                    </ul>
                </p>
                <h2 className='sub_header'>Features</h2>

                <p>
                <ul>
                    <li><b>Conversational AI:</b> Have engaging chats! BogAI's long-term memory allows for more continuous and relevant dialogue.</li>
                    <li><b>Relationship System:</b> Build or break your bond! Every interaction counts towards your relationship level with the bot. Check your status with <b>/profile</b>.</li>
                    <li><b>AI Image Generation:</b> Bring ideas to life! Use <b>/generate_image [prompt]</b> to create images, powered by Google Imagen 3.</li>
                    <li><b>AI Roasts:</b> Have BogAI roast your friends using <b>/roast [user] [optional topic]</b>!</li>
                    <li><b>AI Advice:</b> Get the *BEST* advice from the bog using <b>/advice [your question]</b>.</li>
                    <li><b>User Profiles:</b> See your relationship status and message count with <b>/profile</b>.</li>
                    <li><b>Feedback Channel:</b> Have suggestions? Use <b>/feedback [your message]</b> to reach the developer.</li>
                </ul>
                </p>
                <h2 className='sub_header'>Why choose BogAI?</h2>
                <p>
                    <ul>
                        <li><b>Engagment:</b> Every server that Bog Bot has been added too in my tests as seen an uptick of engagment from users.</li>
                        <li><b>Flexability:</b> With a multitutde of diffrent personalities shape Bog Bot into whatever you want!</li>
                        <li><b>Community Driven:</b> BogAI is built with community feedback in mind. Your suggestions help shape its future!</li>
                        <li><b>Ease of use:</b> All you have to do is add the bot to your sever and you are good to go! No setup up, just start chatting!</li>
                    </ul>
                </p>
        </div>
    );
};

export default About;